import React from 'react';
import ProjectCard from './ProjectCard';
import Heading from './Heading';
function ProjectsList() {
    return (
        <div className="project_list">
            <Heading name="Projects" id="heading" />

            <a name="CLI"><p id="category">CLI</p></a>
            <div className="rowType1">
                <ProjectCard
                    name="Car Showroom Management System"
                    type="C, Terminal-interface"
                    info="Keeps track of cars in a particular showroom and the sales details"
                    website="https://github.com/Ninad10code/CarShowRoomManagementSystem"
                />
            </div>
            <a name="web"><p id="category">Web Development</p></a>
            <div className="rowType1">
                <ProjectCard
                    name="Professional Service Provider"
                    type="HTML,CSS,JSP,MySQL"
                    info="Website to search and book professioinal expert."
                    website="https://github.com/Ninad10code/AWP_project"
                />

                <ProjectCard
                    name="Classroom Portal"
                    type="HTML,CSS,PHP,MySQL"
                    info="Website for students to review grades,attendance & course info."
                    website="https://github.com/Ninad10code/ClassroomPortal-IWP"
                />



            </div>
            <a name="mob"><p id="category">Mobile Application</p></a>
            <div className="rowType1">
                <ProjectCard
                    name="Heap Sort Analysis"
                    type="Flutter app"
                    info="Representation of working of heap sort on flutter app."
                    website="https://github.com/Ninad10code/HeapSort-Analysis"
                />
                <ProjectCard
                    name="BMI Calculator App"
                    type="Flutter app"
                    info="Calculates the Body Mass Index and gives feedback"
                    website="https://github.com/Ninad10code/BMI-Calculator-app"
                />

                <ProjectCard
                    name="Xylophone App"
                    type="Flutter app"
                    info="Play Xylophone instrument right on your smartphone"
                    website="https://github.com/Ninad10code/Xylophone-flutter-app"
                />
            </div>
        </div>
    );
}

export default ProjectsList;